export const MYSQL = 'MYSQL';
export const MARIADB = 'MARIADB';
